import { pageViewTypes } from "@constants/tracking";
/* -----------------Types--------------- */
import AccountSettings from "@features/account/screens/AccountSettings";
import useAnalytics from "@hooks/useAnalytics";
import DocumentTitle from "components/DocumentTitle";
import { useGlobalSearchParams } from "expo-router";

const AccountSettingsRoute = () => {
	useAnalytics({
		type: pageViewTypes.settings,
	});
	const { showBackButton } = useGlobalSearchParams<{
		showBackButton?: string;
	}>();
	return (
		<>
			<DocumentTitle title="Account Settings" />
			<AccountSettings showBackButton={showBackButton === "true"} />
		</>
	);
};

export default AccountSettingsRoute;
